'use strict';

angular.module('magtac')
    .controller('ServerDeleteCtrl', [
        '$scope', 'ServerDeleteViewModel',
        function ($scope, viewModel) {
            $scope.model = new viewModel();
        }
    ]);
